import {createBrowserRouter} from "react-router-dom";
import Home from "../src/pages/page/home"
import Shop from "../src/pages/page/shop"
import ProductDetail from "../src/pages/page/productDetail"
import Aboutus from "../src/pages/page/about"
import Profile from "./pages/page/profile";
import Services from "./pages/page/services";
import Vendors from "./pages/page/vendors";
import Faqs from "./pages/page/faq";
import Sponcers from "./pages/page/sponcers";
import Affilate from "./pages/page/affiliate";
import Blogs from "./pages/page/blog";
import Event from "./pages/page/event";
import Reviews from "./pages/page/reviews";
import Resources from "./pages/page/resources";
import Influencers from "./pages/page/influ";


const Router = createBrowserRouter([
    {
      path: "/",
      element: <Home/>,
    },
]);


const SecureRouter = createBrowserRouter([
    {
        path: "/",
        element: <Home/>,
    },
    {
      path: "/shop",
      element: <Shop/>,
    },
    {
      path:"/productdetail",
      element: <ProductDetail/>,
    },
    {
      path:"/aboutus",
      element:<Aboutus/>
    },
    {
      path:"/profile",
      element:<Profile/>
    },
    {
      path:"/services",
      element:<Services/>
    },
    {
      path:"/vendors",
      element:<Vendors/>
    },
    {
      path:"/faqs",
      element:<Faqs/>
    },
    {
      path:"/sponcers",
      element:<Sponcers/>
    },
    {
      path:"/affilate",
      element:<Affilate/>
    },
    {
      path:"/blogs",
      element:<Blogs/>
    },
    {
      path:"/event",
      element:<Event/>
    },
    {
      path:"/reviews",
      element:<Reviews/>
    },
    {
      path:"/resources",
      element:<Resources/>
    },
    {
      path:"/influencers",
      element:<Influencers/>
    },
]);
  


export {Router, SecureRouter}